/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */

import './mobile-header/primary-links/c-primary-links';
import './mobile-header/mobile-nav-trigger/c-mobile-nav-trigger';
import './mobile-header/mobile-search-trigger/c-mobile-search-trigger';
import './mobile-header/mobile-search/c-mobile-search';
import './back-to-top/c-back-to-top';
import './accordion/c-accordion';
import './child-navigation/c-child-navigation';
import './search-bar/c-search-bar';
import './slider/c-slider';
import './slider/c-slider-homepage';
import './slider/c-slider-timeline';
import './slider/c-slider-configs';
import './modal/c-modal';
import './filtered-listing/c-filtered-listing';
import './desktop-header/desktop-menu/c-desktop-menu';
import './form-elements/c-datepicker';
import './donation-form-single/c-donation-form-single';
import './page-links/c-page-links';
import './form-generic/c-form-generic';
import './search-filters/c-search-filters';
import './quick-donation-form/c-quick-donation-form';
import './impact-calculator/c-impact-calculator';

// New Donation Form
// import './donation-form/c-donation-form';
import './stc-donation-form/c-stc-donation-form';



// WEBPACK FOOTER //
// ./src/components/components.js